export default __webpack_public_path__ + "static/media/Telugu_bf_2.89bf9a9e.mp3";